import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translation } from 'apis';

export const lazyLoadTranslations = async () => {
    const data = await translation.getResources();
    data?.map((lang) => {
        i18n.addResourceBundle(lang.ln, lang.namespace, lang.datavalues);
        return null;
    });
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        partialBundledLanguages: true,
        transSupportBasicHtmlNodes: true,
        lng: window?.CONFIG?.language === "onlyen" ? "en" : null,
        fallbackLng: 'el',
        defaultNS: 'common',
        interpolation: {
            escapeValue: false
        },
        resources: {}
    });

export default i18n;
